import { render, staticRenderFns } from "./ywfw.vue?vue&type=template&id=23350975&scoped=true"
import script from "./ywfw.vue?vue&type=script&lang=js"
export * from "./ywfw.vue?vue&type=script&lang=js"
import style0 from "./ywfw.vue?vue&type=style&index=0&id=23350975&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23350975",
  null
  
)

export default component.exports